<template>
  <label>
    <slot></slot>

    <form-optional-label v-if="optional"></form-optional-label>
  </label>
</template>

 <script>
  export default {
    name: 'form-label',
    props: {
      optional: Boolean
    }
  }
</script>

<style lang="scss" scoped>
  @import '~stylesheets/meta.scss';

  label {
    font-size: 13px;
    margin-bottom: 7px;
    display: inline-block;
    color: $color-brown-grey;
    margin-right: 10px;

    &.group {
      font-size: 14px;
    }

    small {
      font-size: 10px;
      font-style: italic;
      float: right;
      margin-top: 3px;
    }
  }
</style>
